import { Hero } from "../components/medskin/Hero";
import { Marquee } from "../components/medskin/Marquee";
import { About } from "../components/medskin/About";
import { Treatments } from "../components/medskin/Treatments";
import { WhyUs } from "../components/medskin/WhyUs";
import { BeforeAfter } from "../components/medskin/BeforeAfter";
import { Testimonials } from "../components/medskin/Testimonials";
import { CTA } from "../components/medskin/CTA";
import { SEO } from "../components/medskin/SEO";

export default function Landing() {
  return (
    <main className="bg-[#F7F6F3] text-[#2C2C2A] font-sans" data-testid="landing-page">
      <SEO
        title="Medskinby | Klinisk hudklinikk i Oslo – Frogner"
        description="Klinisk hudklinikk i Oslo for akne, rosacea, sensitiv hud, hudbarriere, hormonell ubalanse og anti-age. Medisinsk faglig og helhetlig tilnærming."
        canonical="https://medskinby.no/"
      />
      <Hero />
      <Marquee />
      <About />
      <Treatments />
      <WhyUs />
      <BeforeAfter />
      <Testimonials />
      <CTA />
    </main>
  );
}
